export default __webpack_public_path__ + "static/video-blob-3d659aee5d0175669521369dff93852f.png";